import {
  Box,
  Button,
  Flex,
  Heading,
  Popover,
  PopoverContent,
  PopperTrigger,
  Text,
} from '@modusign/design-system';
import { useState } from 'react';

import DetailInfoItem from '@app/features/externalDocument/components/DetailInfoItem';
import { LabelListSummary } from '@app/features/label';
import LabelApplyModalPopover from '@app/features/label/components/LabelPopovers/LabelApplyPopover';

interface LabelSectionProps {
  index: number;
  labelIds: string[];
  onLabelChange: (labelIds: string[]) => void;
}

export default function LabelSection({ index, labelIds, onLabelChange }: LabelSectionProps) {
  const [isApplyLabelPopoverOpen, setApplyLabelPopoverOpen] = useState(false);

  return (
    <Box as="section" borderBottom="1px solid" borderBottomColor="dividerNeutralLight" pb={7}>
      <Flex alignItems="center" my={8} width="100%">
        <Flex
          alignItems="center"
          bg="statusBackgroundNeutralBase"
          borderRadius="50%"
          fontSize="10px"
          fontWeight="medium"
          height="21px"
          justifyContent="center"
          width="21px"
        >
          {index}
        </Flex>
        <Heading as="h3" flex="auto" fontSize="md" ml={3}>
          라벨 <Text color="textNeutralVeryLight">(선택)</Text>
        </Heading>
      </Flex>
      <Box borderTop="1px solid" borderTopColor="lightGray300">
        <DetailInfoItem name="라벨 적용">
          <LabelListSummary labelIds={labelIds} />
          <Popover
            isOpen={isApplyLabelPopoverOpen}
            mode="click"
            placement="top-start"
            onOpenChange={setApplyLabelPopoverOpen}
          >
            <PopperTrigger>
              <Button height="30px" ml={6} variant="subtle" width="48px">
                설정
              </Button>
            </PopperTrigger>
            <PopoverContent>
              <LabelApplyModalPopover
                initialLabeled={Object.fromEntries(labelIds.map((id) => [id, 'ALL']))}
                mode="limit"
                onSubmit={(data) => {
                  const toAdd = data.filter((lbc) => lbc.apply).map((lbc) => lbc.labelId);
                  onLabelChange(toAdd);
                  setApplyLabelPopoverOpen(false);
                }}
              />
            </PopoverContent>
          </Popover>
        </DetailInfoItem>
      </Box>
    </Box>
  );
}
